(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReleveCompteurControlController', ReleveCompteurControlController);

    ReleveCompteurControlController.$inject = ['$filter', '$http', '$q', '$scope', '$stateParams', '$uibModal', '$window', 'AlertService', 'Principal', 'ReleveCompteur'];

    function ReleveCompteurControlController($filter, $http, $q, $scope, $stateParams, $uibModal, $window, AlertService, Principal, ReleveCompteur) {
        var vm = this;
        var photoObjectUrls = [];
        var user = {};
        var ocrRun = 0;

        vm.analyzeImages = analyzeImages;
        vm.canUseOcr = function() {
            return (user.authorities || []).indexOf('ROLE_SUPER_ADMIN') !== -1 &&
                (user.modules || []).indexOf('OCR') !== -1;
        };
        vm.hasOcrPhotos = function() {
            return vm.controlRows.some(function(row) { return row.hasPhoto; });
        };

        // Une seule requête à la fois ; les autres photos continuent si une analyse échoue.
        function analyzeImages() {
            if (vm.ocrRunning || !vm.canUseOcr()) return;
            var run = ++ocrRun;
            var rows = vm.controlRows.filter(function(row) { return row.hasPhoto; });
            vm.ocrRunning = true;
            vm.ocrCompleted = 0;
            vm.ocrTotal = rows.length;
            var chain = $q.when();
            angular.forEach(rows, function(row) {
                row.ocr = null;
                row.ocrError = null;
                chain = chain.then(function() {
                    if (run !== ocrRun) return;
                    row.ocrLoading = true;
                    return $http.post('api/releve-compteurs/' + row.idReleveCompteur + '/photo/' + row.idLigneReleveCompteur + '/analyze', {}).then(function(response) {
                        if (run === ocrRun) row.ocr = response.data;
                    }).catch(function(error) {
                        if (run === ocrRun) {
                            var errorKey = error.headers && error.headers('X-wamasysApp-error');
                            row.ocrError = $filter('translate')(errorKey || 'wamasysApp.releveCompteur.ocr.failed');
                        }
                    }).finally(function() {
                        row.ocrLoading = false;
                        if (run === ocrRun) vm.ocrCompleted += 1;
                    });
                });
            });
            chain.finally(function() { if (run === ocrRun) vm.ocrRunning = false; });
        }

        vm.allReadingMapPoints = [];
        vm.applyMissingReadingGpsToContracts = applyMissingReadingGpsToContracts;
        vm.applyMissingReadingGpsToMeters = applyMissingReadingGpsToMeters;
        vm.applyReadingGpsToContract = applyReadingGpsToContract;
        vm.applyReadingGpsToMeter = applyReadingGpsToMeter;
        vm.cancelCorrection = cancelCorrection;
        vm.canModify = canModify;
        vm.canShowValidate = canShowValidate;
        vm.canValidate = canValidate;
        vm.caseOptions = [];
        vm.closeMapModal = closeMapModal;
        vm.controlSummary = {};
        vm.controlRows = [];
        vm.controlMode = 'none';
        vm.downloadPhoto = downloadPhoto;
        vm.enableCorrection = enableCorrection;
        vm.getVisibleRows = getVisibleRows;
        vm.isReadingFormComplete = isReadingFormComplete;
        vm.isRowInError = isRowInError;
        vm.isDistanceAlert = isDistanceAlert;
        vm.loadPhoto = loadPhoto;
        vm.mapModal = {
            points: [],
            refreshToken: 0,
            rows: [],
            showContracts: true,
            showMeters: true,
            showReadings: true,
            showRoute: true,
            title: '',
            visible: false
        };
        vm.openAllReadingsMap = openAllReadingsMap;
        vm.openPhotoModal = openPhotoModal;
        vm.openRowMap = openRowMap;
        vm.photoModal = {
            title: '',
            url: null,
            visible: false
        };
        vm.releveCompteur = {};
        vm.saveCorrection = saveCorrection;
        vm.setControlMode = setControlMode;
        vm.showOnlyErrors = false;
        vm.showOnlyFilled = false;
        vm.showOnlyNonReadingCase = false;
        vm.shouldSuggestBulkMeterGpsUpdate = shouldSuggestBulkMeterGpsUpdate;
        vm.updateMapModalPoints = updateMapModalPoints;
        vm.validerReleve = validerReleve;
        vm.refreshHandoffDocument = function() {
            if ($stateParams.id) ReleveCompteur.get({id: $stateParams.id}, refreshControlData);
        };

        $scope.$on('$destroy', revokePhotoObjectUrls);
        $scope.$on('$destroy', function() { ocrRun += 1; });

        Principal.identity().then(function(account) {
            if (account) {
                user = account;
            }
        });

        if ($stateParams.id) {
            ReleveCompteur.get({id: $stateParams.id}, function(result) {
                refreshControlData(result);
            });
        }

        function refreshControlData(releveCompteur) {
            // Une actualisation invalide les résultats et arrête la file d'analyses précédente.
            ocrRun += 1;
            vm.ocrRunning = false;
            vm.ocrTotal = 0;
            revokePhotoObjectUrls();
            vm.releveCompteur = releveCompteur || {};
            vm.caseOptions = angular.isArray(vm.releveCompteur.casNonReleve) ? vm.releveCompteur.casNonReleve : [];
            vm.controlRows = buildControlRows(vm.releveCompteur);
            vm.controlSummary = buildControlSummary(vm.controlRows);
            vm.allReadingMapPoints = buildAllReadingMapPoints(vm.controlRows);

            angular.forEach(vm.controlRows, function(row) {
                if (row.hasPhoto) {
                    loadPhoto(row);
                }
            });
        }

        function buildControlRows(releveCompteur) {
            var rows = [];

            angular.forEach(releveCompteur.clusterReleveCompteurDTO || [], function(clusterDto) {
                angular.forEach(clusterDto.ligneReleveCompteur || [], function(line) {
                    rows.push(buildRow(releveCompteur, line, false, clusterDto.cluster));
                });
            });

            angular.forEach(releveCompteur.listLigneReleveCompteurBulkMeter || [], function(line) {
                rows.push(buildRow(releveCompteur, line, true, null));
            });

            rows.sort(function(a, b) {
                return a.sortValue - b.sortValue;
            });

            return rows;
        }

        function buildRow(releveCompteur, line, isBulkMeter, cluster) {
            var previousValue = toNumber(line.valeurPrecedentReleve);
            var currentValue = toNumber(line.valeurReleve);
            var maxAccepted = toNumber(line.valeurMaximumAccepte);
            var consumption = previousValue !== null && currentValue !== null ? currentValue - previousValue : null;
            var maxAcceptedConsumption = previousValue !== null && maxAccepted !== null ? maxAccepted - previousValue : null;
            var abnormal = currentValue !== null && (
                (maxAccepted !== null && currentValue > maxAccepted) ||
                (previousValue !== null && currentValue < previousValue)
            );
            var readingLat = parseCoordinate(line.coordLat);
            var readingLon = parseCoordinate(line.coordLon);
            var readingPrecision = toNumber(line.coordPrecision);
            var contractLat = parseCoordinate(line.lat);
            var contractLon = parseCoordinate(line.lon);
            var meterLat = resolveMeterLat(line, isBulkMeter);
            var meterLon = resolveMeterLon(line, isBulkMeter);
            var nonReadingCase = line.casNonReleve || null;
            var meterNumber = isBulkMeter ? (line.bulkMeter ? line.bulkMeter.numeroSerie : '') : (line.individualMeter ? line.individualMeter.numeroSerie : '');
            var previousConsumption = resolvePreviousConsumption(line, isBulkMeter);
            var meterUrl = buildMeterUrl(isBulkMeter, line);
            var beneficiaryName = line.nomContrat || '';

            var row = {
                abnormal: abnormal,
                abnormalLabel: abnormal ? $filter('translate')('wamasysApp.releveCompteur.control.abnormal') : $filter('translate')('wamasysApp.releveCompteur.control.normal'),
                beneficiaryName: beneficiaryName,
                clusterLabel: cluster && cluster.numeroSerie ? cluster.numeroSerie : '-',
                consumption: consumption,
                contractGpsLabel: formatCoordinateLabel(contractLat, contractLon),
                contractLat: contractLat,
                contractLon: contractLon,
                contractReference: line.referenceContrat || '',
                contractUrl: line.idContrat ? '#/contrat/' + line.idContrat + '/dataanalyse' : null,
                hasMaxAcceptedCheck: maxAccepted !== null,
                hasMissingReadingGps: readingLat === null || readingLon === null,
                hasPhoto: !!line.pathPhoto,
                hasRecordedReading: currentValue !== null,
                idContrat: line.idContrat,
                idLigneReleveCompteur: line.idLigneReleveCompteur,
                idReleveCompteur: releveCompteur.id,
                isCompleted: currentValue !== null || !!nonReadingCase,
                isBulkMeter: isBulkMeter,
                isEditing: false,
                lineRef: line,
                maxAccepted: maxAccepted,
                maxAcceptedConsumption: maxAcceptedConsumption,
                maxCheckDisabled: isBulkMeter ? !!(line.bulkMeter && line.bulkMeter.disableCheckMaxValue) : !!(line.individualMeter && line.individualMeter.disableCheckMaxValue),
                meterDistanceMeters: null,
                meterGpsLabel: formatCoordinateLabel(meterLat, meterLon),
                meterId: isBulkMeter ? (line.bulkMeter ? line.bulkMeter.id : null) : (line.individualMeter ? line.individualMeter.id : null),
                meterLat: meterLat,
                meterLon: meterLon,
                meterNumber: meterNumber,
                meterType: isBulkMeter ? $filter('translate')('wamasysApp.releveCompteur.typeBulkMeter') : $filter('translate')('wamasysApp.releveCompteur.typeIndividualMeter'),
                meterUrl: meterUrl,
                nonReadingCaseId: nonReadingCase ? nonReadingCase.id : null,
                nonReadingCaseLabel: nonReadingCase ? nonReadingCase.libelle : '',
                photoContentType: null,
                photoDownloadUrl: buildPhotoUrl(releveCompteur.id, line.idLigneReleveCompteur, true),
                photoError: false,
                photoLoading: false,
                photoObjectUrl: null,
                photoTitle: meterNumber || line.referenceContrat || $filter('translate')('wamasysApp.releveCompteur.detail.photo'),
                photoViewUrl: buildPhotoUrl(releveCompteur.id, line.idLigneReleveCompteur, false),
                previousConsumption: previousConsumption,
                previousReadingDateLabel: line.datePrecedentReleveCompteur ? $filter('date')(line.datePrecedentReleveCompteur, 'medium') : '-',
                previousReadingValue: previousValue,
                readingDateLabel: line.readingDate ? $filter('date')(line.readingDate, 'medium') : $filter('date')(releveCompteur.dateReleve, 'mediumDate'),
                readingGpsLabel: formatReadingCoordinateLabel(readingLat, readingLon, readingPrecision),
                readingLat: readingLat,
                readingLon: readingLon,
                readingPrecision: readingPrecision,
                readingValue: line.valeurReleve,
                runningOrderLabel: !isBulkMeter && line.individualMeter && line.individualMeter.runningOrder ? line.individualMeter.runningOrder : '-',
                sortValue: line.readingDate ? new Date(line.readingDate).getTime() : new Date(releveCompteur.dateReleve).getTime()
            };

            resetRowEditingState(row);
            updateDistanceState(row);
            return row;
        }

        function buildPhotoUrl(idReleveCompteur, idLigneReleveCompteur, download) {
            return 'api/releve-compteurs/' + idReleveCompteur + '/photo/' + idLigneReleveCompteur + '?download=' + (download ? 'true' : 'false');
        }

        function buildMeterUrl(isBulkMeter, line) {
            var meterId = isBulkMeter ? (line.bulkMeter ? line.bulkMeter.id : null) : (line.individualMeter ? line.individualMeter.id : null);
            if (!meterId) {
                return null;
            }

            return isBulkMeter ? '#/bulk-meter/' + meterId : '#/individual-meter/' + meterId;
        }

        function buildAllReadingMapPoints(rows) {
            var points = [];

            angular.forEach(rows || [], function(row) {
                if (row.readingLat === null || row.readingLon === null) {
                    return;
                }

                points.push({
                    hasRecordedReading: row.hasRecordedReading,
                    lat: row.readingLat,
                    lon: row.readingLon,
                    orderTime: row.sortValue,
                    dateLabel: row.readingDateLabel,
                    title: row.contractReference || row.meterNumber || '-',
                    subtitle: row.meterNumber,
                    valueLabel: buildReadingValueLabel(row)
                });
            });

            points.sort(function(a, b) {
                return a.orderTime - b.orderTime;
            });

            angular.forEach(points, function(point, index) {
                point.sequence = index + 1;
                point.markerHtml = buildReadingMarkerHtml(point.sequence, point.dateLabel, point.hasRecordedReading);
                point.iconSize = [68, 54];
                point.iconAnchor = [18, 18];
                point.popupAnchor = [0, -16];
            });

            return points;
        }

        function buildControlSummary(rows) {
            var summary = {
                remaining: 0,
                totalNonReading: 0,
                totalRead: 0,
                totalToRead: rows ? rows.length : 0,
                warnings: {
                    abnormal: 0,
                    noGps: 0,
                    shortCheck: 0,
                    wideCheck: 0
                }
            };

            angular.forEach(rows || [], function(row) {
                if (row.hasRecordedReading) {
                    summary.totalRead += 1;
                }
                if (row.nonReadingCaseId) {
                    summary.totalNonReading += 1;
                }
                if (!row.isCompleted) {
                    summary.remaining += 1;
                }
                if (row.abnormal) {
                    summary.warnings.abnormal += 1;
                }
                if (row.hasMissingReadingGps && row.isCompleted) {
                    summary.warnings.noGps += 1;
                }
                if (row.distanceAlertLarge) {
                    summary.warnings.wideCheck += 1;
                }
                if (row.distanceAlertShort) {
                    summary.warnings.shortCheck += 1;
                }
            });

            return summary;
        }

        function buildReadingValueLabel(row) {
            if (row.nonReadingCaseLabel) {
                return $filter('translate')('wamasysApp.releveCompteur.map.nonReading') + ': ' + row.nonReadingCaseLabel;
            }

            if (row.readingValue !== null && row.readingValue !== undefined && row.readingValue !== '') {
                return $filter('translate')('wamasysApp.releveCompteur.map.reading') + ': ' + row.readingValue;
            }

            return $filter('translate')('wamasysApp.releveCompteur.map.noReading');
        }

        function setControlMode(mode) {
            vm.controlMode = mode;
        }

        function getVisibleRows() {
            return (vm.controlRows || []).filter(function(row) {
                if (vm.showOnlyErrors && !isRowInError(row)) {
                    return false;
                }

                if (vm.showOnlyFilled && !isRowFilled(row)) {
                    return false;
                }

                if (vm.showOnlyNonReadingCase && !row.nonReadingCaseId) {
                    return false;
                }

                return true;
            });
        }

        function isRowFilled(row) {
            return !!row && (toNumber(row.readingValue) !== null || !!row.nonReadingCaseId);
        }

        function canModify() {
            return vm.releveCompteur && ['ARENSEIGNER', 'ENCOURS', 'AVALIDER'].indexOf(vm.releveCompteur.etat) !== -1;
        }

        function canShowValidate() {
            return vm.releveCompteur && ['ENCOURS', 'AVALIDER'].indexOf(vm.releveCompteur.etat) !== -1;
        }

        function canValidate() {
            if (!canShowValidate()) {
                return false;
            }

            return vm.releveCompteur.etat === 'ENCOURS' || isReadingFormComplete();
        }

        function isReadingFormComplete() {
            return (vm.controlRows || []).every(function(row) {
                return row.isCompleted;
            });
        }

        function isRowInError(row) {
            return !!row && (row.abnormal || row.hasMissingReadingGps || isDistanceAlert(row));
        }

        function isDistanceAlert(row) {
            if (!row || vm.controlMode === 'none') {
                return false;
            }

            if (vm.controlMode === 'large') {
                return !!row.distanceAlertLarge;
            }

            return !!row.distanceAlertShort;
        }

        function openPhotoModal(row) {
            if (!row || !row.hasPhoto) {
                return;
            }

            loadPhoto(row).then(function() {
                if (!row.photoObjectUrl) {
                    return;
                }

                vm.photoModal.visible = true;
                vm.photoModal.url = row.photoObjectUrl;
                vm.photoModal.title = row.photoTitle;
            });
        }

        function loadPhoto(row) {
            if (!row || !row.hasPhoto) {
                return $q.when();
            }
            if (row.photoObjectUrl) {
                return $q.when(row.photoObjectUrl);
            }
            if (row.photoLoading && row.photoPromise) {
                return row.photoPromise;
            }

            row.photoLoading = true;
            row.photoError = false;
            row.photoPromise = $http.get(row.photoViewUrl, {
                responseType: 'arraybuffer'
            }).then(function(response) {
                var photoBlob = buildPhotoBlob(response.data, response.headers('Content-Type'));
                row.photoContentType = photoBlob.type;
                row.photoObjectUrl = registerPhotoObjectUrl($window.URL.createObjectURL(photoBlob));
                return row.photoObjectUrl;
            }).catch(function(error) {
                row.photoError = true;
                AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.photoDownloadFailed'));
                return null;
            }).finally(function() {
                row.photoLoading = false;
            });

            return row.photoPromise;
        }

        function downloadPhoto(row) {
            if (!row || !row.hasPhoto || row.photoDownloading) {
                return;
            }

            row.photoDownloading = true;
            $http.get(row.photoDownloadUrl, {
                responseType: 'arraybuffer'
            }).then(function(response) {
                var photoBlob = buildPhotoBlob(response.data, response.headers('Content-Type'));
                var fileName = extractFileName(response.headers('Content-Disposition'), row);

                if ($window.navigator.msSaveOrOpenBlob) {
                    $window.navigator.msSaveOrOpenBlob(photoBlob, fileName);
                    return;
                }

                var downloadUrl = $window.URL.createObjectURL(photoBlob);
                var link = $window.document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName;
                $window.document.body.appendChild(link);
                link.click();
                $window.document.body.removeChild(link);
                $window.URL.revokeObjectURL(downloadUrl);
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.photoDownloadFailed'));
            }).finally(function() {
                row.photoDownloading = false;
            });
        }

        function buildPhotoBlob(data, contentType) {
            return new Blob([data], {
                type: contentType || 'image/jpeg'
            });
        }

        function registerPhotoObjectUrl(url) {
            photoObjectUrls.push(url);
            return url;
        }

        function revokePhotoObjectUrls() {
            angular.forEach(photoObjectUrls, function(url) {
                $window.URL.revokeObjectURL(url);
            });
            photoObjectUrls = [];
        }

        function extractFileName(contentDisposition, row) {
            var matches = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(contentDisposition || '');
            if (matches && matches[1]) {
                return decodeURIComponent(matches[1].replace(/"/g, ''));
            }

            return buildFallbackPhotoFileName(row);
        }

        function buildFallbackPhotoFileName(row) {
            var baseName = row.photoTitle || 'photo-compteur';
            if (!/\.[A-Za-z0-9]+$/.test(baseName)) {
                baseName += '.jpg';
            }
            return baseName;
        }

        function openRowMap(row) {
            vm.mapModal.rows = row ? [row] : [];
            vm.mapModal.showReadings = true;
            vm.mapModal.showContracts = true;
            vm.mapModal.showMeters = true;
            vm.mapModal.title = (row.contractReference || row.meterNumber || '') + ' - ' + $filter('translate')('wamasysApp.releveCompteur.control.openMap');
            vm.mapModal.visible = true;
            updateMapModalPoints();
        }

        function openAllReadingsMap() {
            vm.mapModal.rows = vm.controlRows || [];
            vm.mapModal.showReadings = true;
            vm.mapModal.showContracts = true;
            vm.mapModal.showMeters = true;
            vm.mapModal.title = $filter('translate')('wamasysApp.releveCompteur.control.allReadingsMapTitle');
            vm.mapModal.visible = true;
            updateMapModalPoints();
        }

        function closeMapModal() {
            vm.mapModal.visible = false;
            vm.mapModal.points = [];
            vm.mapModal.refreshToken = 0;
            vm.mapModal.rows = [];
            vm.mapModal.showContracts = true;
            vm.mapModal.showMeters = true;
            vm.mapModal.showReadings = true;
            vm.mapModal.showRoute = true;
            vm.mapModal.title = '';
        }

        function updateMapModalPoints() {
            var points = [];
            var readingSequence = 0;

            angular.forEach((vm.mapModal.rows || []).slice().sort(function(firstRow, secondRow) {
                return firstRow.sortValue - secondRow.sortValue;
            }), function(row) {
                if (vm.mapModal.showReadings && row.readingLat !== null && row.readingLon !== null) {
                    readingSequence += 1;
                    points.push(buildMapModalReadingPoint(row, readingSequence));
                }

                if (vm.mapModal.showContracts && row.contractLat !== null && row.contractLon !== null) {
                    points.push(buildMapModalContractPoint(row));
                }

                if (vm.mapModal.showMeters && row.meterLat !== null && row.meterLon !== null) {
                    points.push(buildMapModalMeterPoint(row));
                }
            });

            vm.mapModal.points = points;
            vm.mapModal.showRoute = vm.mapModal.showReadings && !vm.mapModal.showContracts && !vm.mapModal.showMeters && readingSequence > 1;
            vm.mapModal.refreshToken += 1;
        }

        function buildMapModalReadingPoint(row, readingSequence) {
            return {
                dateLabel: row.readingDateLabel,
                focusZoom: 17,
                iconAnchor: [18, 18],
                iconSize: [68, 54],
                key: 'modal-reading-' + row.idLigneReleveCompteur,
                lat: row.readingLat,
                lon: row.readingLon,
                markerHtml: buildReadingMarkerHtml(readingSequence, row.readingDateLabel, row.hasRecordedReading),
                popupAnchor: [0, -16],
                sequence: readingSequence,
                subtitle: row.meterNumber,
                title: row.contractReference || '-',
                valueLabel: row.readingGpsLabel
            };
        }

        function buildMapModalContractPoint(row) {
            return {
                focusZoom: 17,
                iconAnchor: [12, 12],
                iconSize: [24, 24],
                key: 'modal-contract-' + row.idLigneReleveCompteur,
                lat: row.contractLat,
                lon: row.contractLon,
                markerHtml: buildLetterMarkerHtml('C', '#2f855a'),
                popupAnchor: [0, -12],
                subtitle: row.contractReference || '-',
                title: $filter('translate')('wamasysApp.releveCompteur.control.rowMapContract'),
                valueLabel: row.contractGpsLabel
            };
        }

        function buildMapModalMeterPoint(row) {
            return {
                focusZoom: 17,
                iconAnchor: [12, 12],
                iconSize: [24, 24],
                key: 'modal-meter-' + row.idLigneReleveCompteur,
                lat: row.meterLat,
                lon: row.meterLon,
                markerHtml: buildLetterMarkerHtml('M', row.hasRecordedReading ? '#2f855a' : '#c05621'),
                popupAnchor: [0, -12],
                subtitle: row.meterNumber || '-',
                title: $filter('translate')('wamasysApp.releveCompteur.control.rowMapMeter'),
                valueLabel: row.meterGpsLabel
            };
        }

        function enableCorrection(row) {
            if (!canModify()) {
                return;
            }
            row.isEditing = true;
            resetRowEditingState(row);
        }

        function cancelCorrection(row) {
            row.isEditing = false;
            resetRowEditingState(row);
        }

        function saveCorrection(row) {
            if (!row || !row.lineRef || row.savingCorrection) {
                return;
            }
            if (!canModify()) {
                AlertService.error($filter('translate')('wamasysApp.releveCompteur.control.modificationNotAllowed'));
                return;
            }

            var correctionChecks = validateCorrection(row);
            if (correctionChecks.errors.length) {
                AlertService.error(correctionChecks.errors.join(' '));
                return;
            }
            if (correctionChecks.warnings.length && !$window.confirm(correctionChecks.warnings.join('\n') + '\n\n' + $filter('translate')('wamasysApp.releveCompteur.control.forceCorrectionConfirm'))) {
                return;
            }

            row.savingCorrection = true;
            row.lineRef.valeurReleve = normalizeNumber(row.editedReadingValue);
            row.lineRef.casNonReleve = findCaseById(row.editedNonReadingCaseId);

            ReleveCompteur.update(vm.releveCompteur,
                function(result) {
                    row.savingCorrection = false;
                    refreshControlData(result);
                    AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.correctionSaved'));
                },
                function(error) {
                    row.savingCorrection = false;
                    AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.correctionFailed'));
                });
        }

        function validerReleve() {
            if (!vm.releveCompteur || !vm.releveCompteur.id || vm.validatingReleve) {
                return;
            }
            if (!checkerDecimalAquatech()) {
                return;
            }

            // Une RF encore en cours peut contenir des lectures non remontées depuis le smartphone.
            if (requiresValidationConfirmation()) {
                openValidationConfirmation().then(function() {
                    executeValidation();
                });
                return;
            }
            if (!isReadingFormComplete()) {
                AlertService.error($filter('translate')('wamasysApp.releveCompteur.control.validationIncomplete'));
                return;
            }

            executeValidation();
        }

        function requiresValidationConfirmation() {
            return vm.releveCompteur && vm.releveCompteur.etat === 'ENCOURS';
        }

        function openValidationConfirmation() {
            return $uibModal.open({
                templateUrl: 'app/business/releve-compteur/releve-compteur-validate-confirm-dialog.html',
                controller: 'ReleveCompteurValidateConfirmController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md'
            }).result;
        }

        function executeValidation() {
            vm.validatingReleve = true;
            ReleveCompteur.valider({id: vm.releveCompteur.id},
                function(result) {
                    vm.validatingReleve = false;
                    refreshControlData(result);
                    AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.validationSuccess'));
                },
                function(error) {
                    vm.validatingReleve = false;
                    AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.validationFailed'));
                });
        }

        function resetRowEditingState(row) {
            row.editedReadingValue = row.readingValue;
            row.editedNonReadingCaseId = row.nonReadingCaseId;
        }

        function shouldSuggestBulkMeterGpsUpdate(row) {
            return !!row && row.isBulkMeter && canModify() && row.meterId &&
                row.readingLat !== null && row.readingLon !== null &&
                ((row.meterLat === null || row.meterLon === null) || row.distanceAlertLarge || row.distanceAlertShort);
        }

        function applyReadingGpsToContract(row) {
            if (!row || !row.idContrat || row.readingLat === null || row.readingLon === null || row.updatingContract) {
                return;
            }
            if (!$window.confirm($filter('translate')('wamasysApp.releveCompteur.control.confirmContractGpsUpdate'))) {
                return;
            }

            row.updatingContract = true;
            ReleveCompteur.applyReadingGpsToContract({id: row.idReleveCompteur, idLigne: row.idLigneReleveCompteur}, {},
                function() {
                    row.contractLat = row.readingLat;
                    row.contractLon = row.readingLon;
                    row.contractGpsLabel = formatCoordinateLabel(row.contractLat, row.contractLon);
                    updateDistanceState(row);
                    row.updatingContract = false;
                    AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.contractGpsUpdated'));
                },
                function(error) {
                    row.updatingContract = false;
                    AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.contractGpsUpdateFailed'));
                });
        }

        function applyReadingGpsToMeter(row) {
            if (!row || !row.meterId || row.readingLat === null || row.readingLon === null || row.updatingMeter) {
                return;
            }
            if (!$window.confirm($filter('translate')('wamasysApp.releveCompteur.control.confirmMeterGpsUpdate'))) {
                return;
            }

            row.updatingMeter = true;
            ReleveCompteur.applyReadingGpsToMeter({id: row.idReleveCompteur, idLigne: row.idLigneReleveCompteur}, {},
                function() {
                    row.meterLat = row.readingLat;
                    row.meterLon = row.readingLon;
                    row.meterGpsLabel = formatCoordinateLabel(row.meterLat, row.meterLon);
                    updateDistanceState(row);
                    row.updatingMeter = false;
                    AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.meterGpsUpdated'));
                },
                function(error) {
                    row.updatingMeter = false;
                    AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.meterGpsUpdateFailed'));
                });
        }

        function applyMissingReadingGpsToContracts() {
            var rowsToUpdate = vm.controlRows.filter(function(row) {
                return row.idContrat && row.readingLat !== null && row.readingLon !== null && (row.contractLat === null || row.contractLon === null);
            });

            if (!rowsToUpdate.length) {
                AlertService.info($filter('translate')('wamasysApp.releveCompteur.control.noContractGpsToUpdate'));
                return;
            }

            if (!$window.confirm($filter('translate')('wamasysApp.releveCompteur.control.confirmBulkContractGpsUpdate'))) {
                return;
            }

            vm.bulkUpdatingContracts = true;
            applyRowsSequentially(rowsToUpdate, function(row) {
                return ReleveCompteur.applyReadingGpsToContract({id: row.idReleveCompteur, idLigne: row.idLigneReleveCompteur}, {}).$promise;
            }).then(function() {
                return ReleveCompteur.get({id: vm.releveCompteur.id}).$promise;
            }).then(function(result) {
                refreshControlData(result);
                AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.bulkContractGpsUpdated'));
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.contractGpsUpdateFailed'));
            }).finally(function() {
                vm.bulkUpdatingContracts = false;
            });
        }

        function applyMissingReadingGpsToMeters() {
            var rowsToUpdate = vm.controlRows.filter(function(row) {
                return row.meterId && row.readingLat !== null && row.readingLon !== null && (row.meterLat === null || row.meterLon === null);
            });

            if (!rowsToUpdate.length) {
                AlertService.info($filter('translate')('wamasysApp.releveCompteur.control.noMeterGpsToUpdate'));
                return;
            }

            if (!$window.confirm($filter('translate')('wamasysApp.releveCompteur.control.confirmBulkMeterGpsUpdate'))) {
                return;
            }

            vm.bulkUpdatingMeters = true;
            applyRowsSequentially(rowsToUpdate, function(row) {
                return ReleveCompteur.applyReadingGpsToMeter({id: row.idReleveCompteur, idLigne: row.idLigneReleveCompteur}, {}).$promise;
            }).then(function() {
                return ReleveCompteur.get({id: vm.releveCompteur.id}).$promise;
            }).then(function(result) {
                refreshControlData(result);
                AlertService.success($filter('translate')('wamasysApp.releveCompteur.control.bulkMeterGpsUpdated'));
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'wamasysApp.releveCompteur.control.meterGpsUpdateFailed'));
            }).finally(function() {
                vm.bulkUpdatingMeters = false;
            });
        }

        function applyRowsSequentially(rows, action) {
            var promise = $q.when();

            angular.forEach(rows, function(row) {
                promise = promise.then(function() {
                    return action(row);
                });
            });

            return promise;
        }

        function buildReadingMarkerHtml(sequence, dateLabel, hasRecordedReading) {
            var backgroundColor = hasRecordedReading ? '#2f855a' : '#c05621';
            return '<div style="display:flex;flex-direction:column;align-items:center;">' +
                '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:18px;' +
                'min-width:30px;height:30px;line-height:26px;text-align:center;font-weight:bold;' +
                'padding:0 6px;box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">' +
                escapeHtml(sequence) +
                '</div>' +
                '<div style="' +
                'margin-top:3px;background:rgba(255,255,255,0.92);color:#1a202c;border-radius:10px;' +
                'padding:2px 6px;font-size:10px;line-height:1.2;white-space:nowrap;' +
                'box-shadow:0 1px 3px rgba(0,0,0,0.25);">' + escapeHtml(dateLabel || '') + '</div>' +
                '</div>';
        }

        function buildLetterMarkerHtml(label, backgroundColor) {
            return '<div style="' +
                'background:' + backgroundColor + ';color:#fff;border:2px solid #ffffff;border-radius:12px;' +
                'width:24px;height:24px;line-height:20px;text-align:center;font-weight:bold;' +
                'box-shadow:0 1px 5px rgba(0,0,0,0.35);font-size:12px;">' + escapeHtml(label) + '</div>';
        }

        function updateDistanceState(row) {
            row.contractDistanceMeters = computeDistanceMeters(row.readingLat, row.readingLon, row.contractLat, row.contractLon);
            row.meterDistanceMeters = computeDistanceMeters(row.readingLat, row.readingLon, row.meterLat, row.meterLon);
            row.distanceSummaryLabel = buildDistanceSummaryLabel(row);
            row.distanceHeadlineLabel = buildDistanceHeadlineLabel(row);
            row.distanceAlertLarge = hasDistanceAlert(row, 20, false);
            row.distanceAlertShort = hasDistanceAlert(row, 5, true);
        }

        function buildDistanceSummaryLabel(row) {
            var labels = [];

            if (row.meterDistanceMeters !== null) {
                labels.push($filter('translate')('wamasysApp.releveCompteur.control.distanceMeter') + ': ' + $filter('number')(row.meterDistanceMeters, 0) + ' m');
            }
            if (row.contractDistanceMeters !== null) {
                labels.push($filter('translate')('wamasysApp.releveCompteur.control.distanceContract') + ': ' + $filter('number')(row.contractDistanceMeters, 0) + ' m');
            }

            return labels.length ? labels.join(' | ') : '-';
        }

        function buildDistanceHeadlineLabel(row) {
            var labels = [];

            if (row.meterDistanceMeters !== null) {
                labels.push($filter('translate')('wamasysApp.releveCompteur.control.distanceMeterShort') + ' ' + $filter('number')(row.meterDistanceMeters, 0) + ' m');
            }
            if (row.contractDistanceMeters !== null) {
                labels.push($filter('translate')('wamasysApp.releveCompteur.control.distanceContractShort') + ' ' + $filter('number')(row.contractDistanceMeters, 0) + ' m');
            }

            return labels.length ? labels.join(' | ') : '-';
        }

        function hasDistanceAlert(row, baseDistanceMeters, strictPrecisionCheck) {
            var precision = row.readingPrecision !== null && row.readingPrecision !== undefined ? row.readingPrecision : 0;
            var maxDistance = baseDistanceMeters + Math.max(precision, 0);

            if (strictPrecisionCheck && precision > 5) {
                return true;
            }

            return exceedsDistance(row.contractDistanceMeters, maxDistance) || exceedsDistance(row.meterDistanceMeters, maxDistance);
        }

        function exceedsDistance(distanceMeters, maxDistance) {
            return distanceMeters !== null && distanceMeters > maxDistance;
        }

        function computeDistanceMeters(lat1, lon1, lat2, lon2) {
            if (lat1 === null || lon1 === null || lat2 === null || lon2 === null) {
                return null;
            }

            var earthRadius = 6371000;
            var dLat = degreesToRadians(lat2 - lat1);
            var dLon = degreesToRadians(lon2 - lon1);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(degreesToRadians(lat1)) * Math.cos(degreesToRadians(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            return earthRadius * c;
        }

        function degreesToRadians(value) {
            return value * Math.PI / 180;
        }

        function resolveMeterLat(line, isBulkMeter) {
            if (isBulkMeter) {
                return parseCoordinate(line.bulkMeter && line.bulkMeter.latitude);
            }
            return parseCoordinate(line.individualMeter && line.individualMeter.latitude);
        }

        function resolveMeterLon(line, isBulkMeter) {
            if (isBulkMeter) {
                return parseCoordinate(line.bulkMeter && line.bulkMeter.longitude);
            }
            return parseCoordinate(line.individualMeter && line.individualMeter.longitude);
        }

        function formatReadingCoordinateLabel(lat, lon, precision) {
            if (lat === null || lon === null) {
                return '-';
            }

            var label = formatCoordinateLabel(lat, lon);
            if (precision !== null && precision !== undefined) {
                label += ' (' + $filter('number')(precision, 1) + ' m)';
            }
            return label;
        }

        function formatCoordinateLabel(lat, lon) {
            if (lat === null || lon === null) {
                return '-';
            }

            return $filter('number')(lat, 6) + ', ' + $filter('number')(lon, 6);
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function normalizeNumber(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function findCaseById(id) {
            if (id === null || id === undefined || id === '') {
                return null;
            }

            var searchedId = parseInt(id, 10);
            var selectedCase = null;
            angular.forEach(vm.caseOptions, function(caseItem) {
                if (!selectedCase && caseItem && caseItem.id === searchedId) {
                    selectedCase = {
                        id: caseItem.id,
                        libelle: caseItem.libelle
                    };
                }
            });

            return selectedCase;
        }

        function resolveErrorMessage(error, defaultTranslationKey) {
            if (error && error.data && error.data.message) {
                return error.data.message;
            }
            return $filter('translate')(defaultTranslationKey);
        }

        function escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }

        function toNumber(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = parseFloat(value);
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function resolvePreviousConsumption(line, isBulkMeter) {
            if (isBulkMeter) {
                return toNumber(line.valeurPrecedenteConsommation || (line.bulkMeter && line.bulkMeter.valeurPrecedenteConsommation));
            }

            return toNumber(line.individualMeter && line.individualMeter.valeurPrecedenteConsommation);
        }

        function validateCorrection(row) {
            var errors = [];
            var warnings = [];
            var editedReadingValue = normalizeNumber(row.editedReadingValue);

            if (editedReadingValue !== null && editedReadingValue < 0) {
                errors.push($filter('translate')('wamasysApp.releveCompteur.control.correctionValidationNegative'));
            }

            if (editedReadingValue !== null && row.previousReadingValue !== null && editedReadingValue < row.previousReadingValue) {
                warnings.push($filter('translate')('wamasysApp.releveCompteur.control.correctionValidationPrevious'));
            }

            if (editedReadingValue !== null && row.maxAccepted !== null && editedReadingValue > row.maxAccepted) {
                warnings.push($filter('translate')('wamasysApp.releveCompteur.control.correctionValidationMax'));
            }

            return {
                errors: errors,
                warnings: warnings
            };
        }

        function hasDecimals(number) {
            return number % 1 !== 0;
        }

        function checkerDecimalAquatech() {
            var erreur = false;
            var messageErreur = '';
            var organisationName = user.organisationName || '';

            if (organisationName.indexOf('Aquatech') === -1 && organisationName.indexOf('aquatech') === -1
                && user.organisationId !== 26529364 && user.organisationId !== 25683601) {
                return true;
            }

            angular.forEach(vm.releveCompteur.clusterReleveCompteurDTO || [], function(clusterDto) {
                angular.forEach(clusterDto.ligneReleveCompteur || [], function(line) {
                    if (line.valeurReleve && hasDecimals(line.valeurReleve)) {
                        erreur = true;
                        messageErreur += 'Erreur releve avec decimale sur ' + ((line.individualMeter && line.individualMeter.numeroSerie) || '-') + '\n';
                    }
                });
            });

            angular.forEach(vm.releveCompteur.listLigneReleveCompteurBulkMeter || [], function(line) {
                if (line.valeurReleve && hasDecimals(line.valeurReleve)) {
                    erreur = true;
                    messageErreur += 'Erreur releve avec decimale sur ' + ((line.bulkMeter && line.bulkMeter.numeroSerie) || '-') + '\n';
                }
            });

            if (erreur) {
                $window.alert('Vous avez des erreurs bloquantes pour la validation du releve de compteur : \n' + messageErreur);
                return false;
            }

            return true;
        }
    }
})();
